/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const ProfilePic = {
  url: require("./assets/images/dp.png"),
  show: "true"
};

const greeting = {
  username: "Arbaaz Ali",
  title: "Nice to see you, I'm Arbaaz",
  subTitle: emoji(
    "A passionate Frontend Engineer 🚀 who loves to develop and scale web applications with his expertise, eager to learn and take on new challenges"
  ),
  resumeLink:
    "https://drive.google.com/file/d/1HexWlv8KpgUhqs5h-nvnY0tGiiwbbFSB/view?usp=sharing", //resume-link
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/arbaaz833",
  linkedin: "https://www.linkedin.com/in/arbaaz-ali-b2b016166/",
  gmail: "arbaazali031@gmail.com",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle:
    "Develop new web applications and adds value to existing one through my work",
  skills: [
    emoji("⚡ Develop highly interactive and feature oriented user interfaces"),
    emoji(
      "⚡ Refactor and eleminate performance bottlenecks from existing code"
    ),
    emoji("⚡ learn and polish my existing skills to enhance my expertise"),
    emoji(
      "⚡ collaborate with backend developers and designers to improve application usability"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "vuejs",
      fontAwesomeClassname: "fab fa-vuejs"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "git",
      fontAwesomeClassname: "fab fa-git-alt"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "NED University",
      logo: require("./assets/images/ned_logo.png"),
      subHeader: "Bachelors of Materials Engineering",
      duration: "December 2015 - July 2019",
      // desc: "Participated in the research of XXX and published 3 papers.",
      descBullets: [
        "4 GPA (A+ Grade) in Computer Programming And Drafting (IM-207)"
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Javascript",
      progressPercentage: "90%"
    },
    {
      Stack: "Reactjs", //Insert stack or technology you have experience in
      progressPercentage: "88%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Problem Solving",
      progressPercentage: "85%"
    },
    {
      Stack: "Vuejs",
      progressPercentage: "75%"
    },
    {
      Stack: "Nextjs",
      progressPercentage: "70%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Frontend Engineer",
      company: "Metru",
      companylogo: require("./assets/images/metru.jpg"),
      date: "August 2022 – Present",
      descBullets: [
        "Implemented the functionality to accurately track the time and views on the candidate profile giving them accurate insights from recruiters",
        "Refactored and replaced the code for sequential API calls to perform the tasks in parallel on the candidate document upload section, reducing the time for upload",
        "Proposed best approaches and worked Single-handedly on the main features of the product ensuring best practices and code quality",
        "Developed Email formatter by integrating Quill.js with vue that outputs inline-styled HTML email template",
        "Efficiently collaborated with designers to implement optimized user flow in the features"
      ]
    },
    {
      role: "Frontend Developer",
      company: "Dechains",
      companylogo: require("./assets/images/dechains.jpg"),
      date: "April 2022 – August 2022",
      descBullets: [
        "Implemented a reuseable logic for real time notifications in a web app by creating a custom react hook for it and utilizing REST API polling for the purpose",
        "Developed highly aesthetic Web 3.0 websites on Reactjs translating Figma designs",
        "Collaborated with backend developers to integrate frontend components with APIs, ensuring efficient data retrieval and synchronization"
      ]
    },
    {
      role: "Frontend Developer",
      company: "Trendshakers",
      companylogo: require("./assets/images/trendshakers.png"),
      date: "May 2021– March 2022",
      descBullets: [
        "Integrated Rich text editor for notes management feature using Draft.js",
        "Developed Patient management system utilizing Reactjs on frontend and cloud firestore as a backend service",
        "Integrated RBAC on the frontend by dynamically changing UI components and user's access based on their roles",
        "Translated figma designs into responsive and reuseable components"
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: false, // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Portfolio Projects",
  subtitle: "",
  projects: [
    {
      images: [
        require("./assets/images/Physikomatics/PH-1.png"),
        require("./assets/images/Physikomatics/PH-2.png"),
        require("./assets/images/Physikomatics/PH-3.png"),
        require("./assets/images/Physikomatics/PH-4.png"),
        require("./assets/images/Physikomatics/PH-5.png"),
        require("./assets/images/Physikomatics/PH-6.png"),
        require("./assets/images/Physikomatics/PH-7.png"),
        require("./assets/images/Physikomatics/PH-8.png"),
        require("./assets/images/Physikomatics/PH-9.png"),
        require("./assets/images/Physikomatics/PH-10.png"),
        require("./assets/images/Physikomatics/PH-11.png"),
        require("./assets/images/Physikomatics/PH-12.png"),
        require("./assets/images/Physikomatics/PH-13.png"),
        require("./assets/images/Physikomatics/PH-14.png"),
        require("./assets/images/Physikomatics/PH-15.png"),
        require("./assets/images/Physikomatics/PH-16.png")
      ],
      projectName: "Physikomatics",
      projectDesc:
        "Physikomatics is an innovative EdTech platform built to improve student preparation for career aptitude tests. It features dedicated admin and teacher panels for managing batches, tests, bi-weekly assessments, teachers, and students, as well as conducting live classes seamlessly.\n\n<strong>Tech Stack: </strong>ReactJS, Typescript, Tailwind CSS, RTK, Ant design,Axios",
      descBullets: [
        "Integrated YouTube Data API to enable seamless class creation directly within the app, improving teacher experience",
        "Implemented real-time messaging and group chats using Socket.io, enhancing collaboration between teachers.",
        "Designed and managed the complete JWT authentication flow, leveraging Axios interceptors for secure API communication and token refresh handling",
        "Developed URL state synchronization across the application, enabling persistent user filters and shareable URLs, reducing onboarding friction and improving usability",
        "Integrated Firebase Cloud Messaging (FCM) to deliver push notifications, enhancing user engagement and awareness.",
        "Utilized MathJax to display complex mathematical equations and built a dynamic real-time rendering component for user-driven equation inputs."
      ],
      footerLink: []
    },
    {
      images: [
        require("./assets/images/sensei/1.png"),
        require("./assets/images/sensei/2.png"),
        require("./assets/images/sensei/3.png"),
        require("./assets/images/sensei/4.png"),
        require("./assets/images/sensei/5.png"),
        require("./assets/images/sensei/6.png")
      ],
      projectName: "Sensei Games",
      projectDesc:
        "A platform for kids to learn and visualize programming concepts through simple game tasks.\n\n<strong>Tech Stack: </strong>ReactJS, Typescript, Tailwind CSS, Blockly, Konva",
      descBullets: [
        "Developed a game engine for rendering 2d sketches based on the generated javascript code utilising konva.js with react for the purpose.",
        "Written complex logic for a multi-checkpoint game to simulate the conditionals concept of programming, leverages CSS animations with absolute positioning to animate objects movement in the game.",
        "Used tailwind CSS for decorative styling and mobile first UI."
      ],
      footerLink: [
        {
          name: "Open App",
          url: "https://www.senseiigames.com/"
        }
      ]
    },
    {
      images: [
        require("./assets/images/VectorLinkUserPanel/1.png"),
        require("./assets/images/VectorLinkUserPanel/2.png"),
        require("./assets/images/VectorLinkUserPanel/3.png"),
        require("./assets/images/VectorLinkUserPanel/4.png"),
        require("./assets/images/VectorLinkUserPanel/5.png"),
        require("./assets/images/VectorLinkUserPanel/6.png")
      ],
      projectName: "Vector Link User Panel",
      projectDesc:
        "A SASS based VPN service.\n\n<strong>Tech Stack: </strong>Reactjs, Redux, RTK, SCSS, Ant Design.",
      descBullets: [
        "Leverage REST API polling to get the most updated transaction status for the user purchases.",
        "Implemented RBAC(user and reseller) to change the User flow based on its role.",
        "Added HCaptcha to detect real users on signup.",
        "Created reuseable and responsive components translating figma designs.",
        "Applied optimized user flow throughout the app to eleminate any anti-pattern and edge case.",
        "Handled expiry of user session on frontend using expiry date object from backend."
      ],
      footerLink: [
        {
          name: "Open User Panel",
          url: "https://app.vectorlink.io/signup"
        }
      ]
    },
    {
      images: [
        require("./assets/images/VectorLinkAdmin/sc1.png"),
        require("./assets/images/VectorLinkAdmin/sc2.png"),
        require("./assets/images/VectorLinkAdmin/sc3.png"),
        require("./assets/images/VectorLinkAdmin/sc4.png"),
        require("./assets/images/VectorLinkAdmin/sc5.png"),
        require("./assets/images/VectorLinkAdmin/sc6.png"),
        require("./assets/images/VectorLinkAdmin/sc7.png"),
        require("./assets/images/VectorLinkAdmin/sc8.png"),
        require("./assets/images/VectorLinkAdmin/sc9.png"),
        require("./assets/images/VectorLinkAdmin/sc10.png")
      ],
      projectName: "Vector Link Admin Panel",
      projectDesc:
        "An Admin Panel to manage VPN service.\n\n<strong>Tech Stack: </strong>Reactjs, RTK, Ant Design, scss.",
      descBullets: [
        "strategically planned and designed the tables UI to come up with best UX for managing users, servers, giftCards, plans and resellers as the admin of service.",
        "Efficiently handled and synced data between redux store, components and database to maintain consistent reflect of data throughout the Admin Panel."
      ],
      footerLink: [
        {
          name: "Open Admin Panel",
          url: "https://admin.vectorlink.io/login"
        }
      ]
    },
    {
      images: [
        require("./assets/images/AAForms/1.png"),
        require("./assets/images/AAForms/2.png"),
        require("./assets/images/AAForms/3.png"),
        require("./assets/images/AAForms/4.png"),
        require("./assets/images/AAForms/5.png"),
        require("./assets/images/AAForms/6.png")
      ],
      projectName: "AA Forms",
      projectDesc:
        "A Form service application just like Google Forms in functionality.\n\n<strong>Tech Stack: </strong>ReactJS, Cloud Firestore, Javascript, Ant Design Charts.",
      descBullets: [
        "Created a custom component for the creation of forms and manage its settings.",
        "Developed a panel to manage all the forms, view all or individual responses, edit , delete or share the forms.",
        "Implemented Ant Design Charts to represent responses to a form in a meaningful way.",
        "Designed database model and schema for cloud firestore."
      ],
      footerLink: [
        {
          name: "Open App",
          url: "https://aa-survey-form.web.app/auth/home"
        }
      ]
    },
    {
      images: [
        require("./assets/images/UNO/1.png"),
        require("./assets/images/UNO/2.png"),
        require("./assets/images/UNO/3.png"),
        require("./assets/images/UNO/4.png"),
        require("./assets/images/UNO/5.png"),
        require("./assets/images/UNO/6.png")
      ],
      projectName: "UNO Game",
      projectDesc:
        "A complete UNO game developed on vanilla javascript in which you can compete with CPU player on predifined score.\n\n<strong>Tech Stack: </strong>Javascript, HTML, CSS.",
      descBullets: [
        "Build Algorithm to implement complete UNO game logic.",
        "Handled DOM updates according to the user actions in the game.",
        "Implemented game loop and handled different cases logic to correctly assign turn to correct player based on the game situation."
      ],
      footerLink: [
        {
          name: "Play Game",
          url: "https://uno-game-d1a79.web.app/homepage.html"
        }
      ]
    },
    {
      images: [
        require("./assets/images/Crehab/1.png"),
        require("./assets/images/Crehab/2.png"),
        require("./assets/images/Crehab/3.png"),
        require("./assets/images/Crehab/4.png"),
        require("./assets/images/Crehab/5.png")
      ],
      projectName: "EMR Web App",
      projectDesc:
        "An Electronic Record Management Application.\n\n<strong>Tech Stack: </strong>React, Redux, Firestore, SCSS, Ant Design.",
      descBullets: [
        "Developed a patient management system and added RBAC(role based access control) in it, utilizing React and Redux on the frontend and cloud firestore as a backend",
        "Integrated a rich text editor for patient notes management utilizing draft.js.",
        "Handled RBAC on the frontend by dynamically changing UI components and user access based on their roles.",
        "Translated figma designs into responsive and reusable components."
      ],
      footerLink: [
        {
          name: "Open App",
          url: "https://emr.crehabconsultants.com/login"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  // subtitle:"My ",
  achievementsCards: [
    {
      title: "Javascript Algorithms and Data Structure",
      // subtitle:
      //   "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/certifications/JSDSA.png"),
      imageAlt: "DSA",
      footerLink: [
        {
          name: "View Certificate",
          url: "https://www.freecodecamp.org/certification/ArbaazA/javascript-algorithms-and-data-structures"
        }
      ]
    },
    {
      title: "Javascript (HackerRank)",
      // subtitle:
      //   "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/certifications/javascript.png"),
      imageAlt: "JS Certificate",
      footerLink: [
        {
          name: "View Certificate",
          url: "https://www.hackerrank.com/certificates/4b78bfadae80"
        }
      ]
    },

    {
      title: "Problem Solving (HackerRank)",
      // subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/certifications/problemSolving.png"),
      imageAlt: "Problem Solving Certificate",
      footerLink: [
        {
          name: "View Certificate",
          url: "https://www.hackerrank.com/certificates/8ce18bcee210"
        }
      ]
    },

    {
      title: "React (HackerRank)",
      // subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/certifications/react.png"),
      imageAlt: "React Certificate",
      footerLink: [
        {
          name: "View Certificate",
          url: "https://www.hackerrank.com/certificates/0d7c15adca22"
        }
      ]
    },

    {
      title: "CSS (HackerRank)",
      // subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/certifications/css.png"),
      imageAlt: "CSS Certificate",
      footerLink: [
        {
          name: "View Certificate",
          url: "https://www.hackerrank.com/certificates/0d7c15adca22"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Want to have a conversation about project or any role, feel free to contact me",
  number: "+923443558218"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  ProfilePic
};
